<template>
  <div>
    <router-link :to="{ name: 'UserSingle', params: { id: user.slug }}" class="user-card" v-b-tooltip.hover :title="user.nickname">
      <div class="user-image">
        <b-img :src="user.avatar.url" :alt="user.nickname" />
      </div>
      <div class="user-content">
        <h4 v-html="user.nickname"></h4>
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'UserCard',
  props: {
    user: Object
  }
}
</script>

<style scoped lang="sass">
.user-card
  width: 48px
  height: 48px
  display: block
  margin: 0 -5px 5px 0
  // background: rgba(0, 0, 0, .2)
  transition: all .2s
  position: relative
  border-radius: 100%
  border: 2px solid rgba(255, 255, 255, .2)
  // box-shadow: 0px 0px 1px rgba(255, 255, 255, .4)

  &:hover
    color: black
    text-decoration: none
    .user-image
      img
        transform: scale(1.2)

    .user-content
      // h4
      //   color: white
      //   display: block
      // background: rgba(0, 0, 0, .8)
      // border-radius: 100%
      
  .user-image
    width: 100%
    height: 100%
    overflow: hidden
    border-radius: 100%
    img
      width: auto
      height: 100%
      object-fit: cover
      transition: all .2s
      border-radius: 100%
    
  .user-content 
    width: 100%
    height: 100%
    padding: 20px
    color: #ccc !important

    overflow: hidden

    position: absolute
    top: 0
    left: 0

    // background: rgba(0, 0, 0, .7)

    h4
      font-weight: bold
      margin-bottom: 5px
      color: rgba(255, 255, 255, .6)
      transition: all .2s
      display: none
</style>
